import styled from 'styled-components'

const StyledLessonResourceListItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  padding: 10px;
  border-radius: 8px;
  margin: -10px;
  transition: 0.2s;
  color: ${({ theme }) => theme.color.gray[600]};

  .details {
    display: flex;
    align-items: center;

    .icon {
      height: 36px;
      width: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${({ theme }) => theme.color.gray[900]}10;
      color: ${({ theme }) => theme.color.gray[600]};
      border-radius: 6px;
      margin-right: 14px;

      svg {
        height: 20px;
      }
    }

    .label {
      font-weight: 500;
      font-size: 15px;
    }
  }

  .download-icon {
    height: 24px;
    transition: 0.2s;
    color: ${({ theme }) => theme.color.gray[400]};
  }

  &:hover {
    cursor: alias;
    color: ${({ theme }) => theme.color.gray[900]};
    background-color: ${({ theme }) => theme.color.gray[100]};

    .download-icon {
      color: ${({ theme }) => theme.color.gray[900]};
    }
  }
`

export default StyledLessonResourceListItem
